const KEY = "cannac_events";

type EventRow = { event: string; at: number; props?: Record<string, string | number> };

export function track(event: string, props?: Record<string, string | number>) {
  const row: EventRow = { event, at: Date.now(), props };
  try {
    const prev: EventRow[] = JSON.parse(localStorage.getItem(KEY) || "[]");
    prev.push(row);
    if (prev.length > 200) prev.splice(0, prev.length - 200);
    localStorage.setItem(KEY, JSON.stringify(prev));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent("cannac:analytics", { detail: row }));
}
